import { GoASpacer } from '@abgov/react-components';
import { BaseWizardProps } from '../wizard/wizard-step-base';
import { WizardButtonGroup } from '../wizard/wizard-button-group-component';
import { AppDispatch, RootState } from '../../state/store';
import { useDispatch, useSelector } from 'react-redux';
import { useIsDesktop } from '../../utils/isDesktop';
import { useEffect, useState } from 'react';

import styles from './damage.module.css';
export interface DamageIntroductionComponentProps extends BaseWizardProps {}

const useAppDispatch = () => useDispatch<AppDispatch>();
const useAppSelector: <TSelected>(
  selector: (state: RootState) => TSelected,
) => TSelected = useSelector;

export const DamageIntroductionComponent = ({
  navigationConfiguration,
}: DamageIntroductionComponentProps) => {
  const isDesktop = useIsDesktop();
  const defaultSelection = '0';

  const errorText = 'Choose one an option that best applies to your situation';
  const dispatch = useAppDispatch();

  const stateCollision = useAppSelector((state: RootState) => state.collision);
  const stateConfiguration = useAppSelector(
    (state: RootState) => state.configuration,
  );

  const [nextPage, setNextPage] = useState('');
  useEffect(() => {
    const pageConfig = navigationConfiguration.pagingConfiguration.find(
      (item) => item.default !== undefined,
    );

    setNextPage(pageConfig?.default ?? 'error');
  }, []);

  return (
    <div>
      <h1>Vehicle damage</h1>
      <GoASpacer vSpacing={'l'} />
      Review the steps below to accurately indicate your vehicle damage.
      <GoASpacer vSpacing={'2xl'} />
      <div className={styles.header}>
        <span className={styles.circle}>1</span>
        <div style={{ font: 'var(--goa-typography-heading-m)' }}>
          Indicate your vehicle damage
        </div>
      </div>
      <GoASpacer vSpacing={'s'} />
      Use the interactive indicators on the vehicle diagram to select the
      location(s) of all areas of vehicle damage.
      <GoASpacer vSpacing={'xl'} />
      <div className={styles.header}>
        <span className={styles.circle}>2</span>
        <div style={{ font: 'var(--goa-typography-heading-m)' }}>
          Indicate your first point of damage
        </div>
      </div>
      <GoASpacer vSpacing={'s'} />
      Identify the area of your vehicle that was damaged first in the collision
      (the first point of impact).
      <WizardButtonGroup
        nextPage={nextPage}
        validate={() => {
          return true;
        }}
        save={navigationConfiguration.save}
        goToReview={navigationConfiguration.goToReview}
        navigate={navigationConfiguration.navigate}
        buttonText="Continue"
      />
    </div>
  );
};
